import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'lx-prices-disclaimer',
  templateUrl: './prices-disclaimer.component.html',
  styleUrls: ['./prices-disclaimer.component.scss'],
})
export class PricesDisclaimerComponent {}
